<div class="columns has-background-white">
  <div class="column custom-box p-3">
    <code *ngIf=" airCompanyNotes$ | async as airCompanyNotes" [innerHTML]="airCompanyNotes"></code>
  </div>
</div>
